import Axios from 'axios';
import UserSessionService from '@/services/userSessionService';
import store from '@/store';
// import delayRequestAdapter from '@/plugins/axios/adapters/delayRequestAdapter.js';
import router from '@/router';

let baseUrl;
if (process.env.NODE_ENV === 'development') {
  baseUrl = 'http://localhost:21021';
} else {
  baseUrl = document.location.origin + '';
}

const createAxiosInstance = (config = null) => {
  const axiosInstance = config ? Axios.create(config) : Axios.create();
  axiosInstance.interceptors.response.use(
    response => response,
    error => {
      if (error.response.status === 450) {
        try {
          router.replace({ path: '/login', query: { alreadySignedIn: true } });
        } catch {
          // ignore duplicate path error
        }
      }
    }
  );
  return axiosInstance;
};

export { baseUrl };

export const httpService = createAxiosInstance();

export function createAuthHttp() {
  const token = UserSessionService.getToken();
  const tokenHeader = token ? `Bearer ${token}` : null;
  const headers = {
    Authorization: tokenHeader
  };

  return Axios.create({ headers });
}

export function createMockAuthHttp(result, timeout = 300) {
  return new Promise(resolve => {
    setTimeout(() => {
      const response = {
        data: result,
        config: {},
        headers: null,
        request: null,
        status: 200,
        statusText: ''
      };
      resolve(response);
    }, timeout);
  });
}

export default class ApiBase {
  constructor(baseUrl, token = null) {
    this.baseUrl = baseUrl;
    this.token = token || store.getters['account/token'];
  }

  get authHttp() {
    if (!this.token) {
      throw 'Client is not authenticated';
    }

    const tokenHeader = this.token ? `Bearer ${this.token}` : null;
    const headers = {
      Authorization: tokenHeader
    };
    return createAxiosInstance({ headers /*, adapter: delayRequestAdapter(3000)*/ });
  }

  get http() {
    return createAxiosInstance();
  }

  downloadFile(response, fileName) {
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
  }
}
